module.exports = __webpack_public_path__ + "img/63600.bb80609b.jpg";